import { PERMISSION } from '@/constants/permission.constant';

const brandList = () => import('@/views/configuration/brands/List.vue');
const addBrand = () => import('@/views/configuration/brands/Add.vue');
const editBrand = () => import('@/views/configuration/brands/Edit.vue');

export const brandRoute = [
  {
    path: '/configuration/brands',
    name: 'brand-list',
    component: brandList,
    meta: { requiresAuth: false, permissions: [PERMISSION.BRAND_READ] },
  },

  {
    path: '/configuration/brands/create',
    name: 'brand-create',
    component: addBrand,
    meta: { requiresAuth: false, permissions: [PERMISSION.BRAND_CREATE] },
  },
  {
    path: '/configuration/brands/update',
    name: 'brand-edit',
    component: editBrand,
    meta: { requiresAuth: false, permissions: [PERMISSION.BRAND_UPDATE] },
  },
];
